import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDemoAppContext } from './DemoAppContext';
import './DemoAppLoginScreen.css';

const CORRECT_PASSPHRASE = 'feedfm-demo-2025';

const LoginScreen = () => {
  const { setDoorPasswordProvided } = useDemoAppContext();
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (passphrase === CORRECT_PASSPHRASE) {
      setDoorPasswordProvided(true);
    } else {
      setError(true);
    }
  };

  return (
    <Box className="login-container">
      <Paper elevation={3} className="login-paper">
        <Typography variant="h4" component="h1" gutterBottom>
          Feed.fm Clips Demo
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Please enter the passphrase to access the demo
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Passphrase"
            variant="outlined"
            value={passphrase}
            onChange={(e) => {
              setPassphrase(e.target.value);
              setError(false);
            }}
            error={error}
            helperText={error ? 'Incorrect passphrase' : ''}
            sx={{ mb: 2 }}
          />
          <Button fullWidth variant="contained" type="submit" size="large">
            Enter
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginScreen;
